import './index.css';

const Footer = () => (
  <footer className="footer">
    <div className="footer__inner">
      <span className="footer__copy">
        {`© ${new Date().getFullYear()} Sébastien Friedberg`}
      </span>
      <span className="footer__credit">
        Designed &amp; built with intent
      </span>
    </div>
  </footer>
);

export default Footer;
